import { render, staticRenderFns } from "./classdetail.vue?vue&type=template&id=0e27dcc8&scoped=true&"
import script from "./classdetail.vue?vue&type=script&lang=js&"
export * from "./classdetail.vue?vue&type=script&lang=js&"
import style0 from "./classdetail.vue?vue&type=style&index=0&id=0e27dcc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e27dcc8",
  null
  
)

export default component.exports